import { useMediaQuery } from 'react-responsive'


export const device = {
    tablet: `(max-width: 768px)`
}

export const useResponsiveUtil = () => {

    const isTabletDevice = useMediaQuery({
        query: device.tablet,
    });

    return { isTabletDevice }
}
